import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../service/api.service';
import {Router} from "@angular/router"
import { CoreService } from '../../service/core.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatTabGroup } from '@angular/material/tabs';
import { environment } from '../../../environments/environment';
import { SystemIdService } from 'src/app/system-id.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [NgbModalConfig, NgbModal]
})
export class HeaderComponent implements OnInit {  

    @ViewChild('myTabGroup', { static: false }) tabGroup: MatTabGroup;

  search_res: string[];
  token: string;
  display_name:String; 
  eInvoiceSupport: boolean=false;
  eInvoiceSupportAdmin: boolean=false;
  branch_name:String;
  display_code:String;
  branch_e_invoice_enabled = 0;
  desktoken: any;
  user_name:String;
  photo:any;
  base_url: string;
  usr_username: any;
  // headerSalesEinvoiceLink=0;
  search_inp : any;
  show_production = false;
  cheq_issue_date: Date = new Date();
  pdc_count: any;
  batch_ex_count: any;
  admin_notification:any;
  up: any;
  checkBatch =false;
  so_count= <any>0;
  txn_edit_req_count = <any>0;
  userType: any;
  show_component: boolean;
  user_id: any;
  usr_edit_transaction_approval: any;
  einvoice_count: any;
  show_documentation= false;
  cmpny = '';
  saledue_count= <any>0;
  purchasedue_count= <any>0;
  invrequest_count: any=0;
  invrequest_list: any;
  status = {
    '0': 'Pending',
    '1': 'Approved',
    '2': 'Rejected',
    '3': 'Cancelled',
  };
  list_all: any;


  is_rest_pos_enabled = false;
  private searchProductSubject = new Subject<string>();
  prod_alias: any;
  search = [];
  showProductList: boolean = false;
  productDetails: any;
  prodLoader: boolean;
  unit_available_stock: any;
  godownStocks: any;
  vanStocks: any;
  otherBranchStocks: any;

  selectedData: any = {
    prd_id: null, prd_name: null, error: null, message: null, prd_sub_cat_id: null, prd_cat_id: null,
    prd_base_unit_id: null, prd_minstock_alert: null, prd_maxstock_alert: null, prd_unit_ids: null,
    prd_default_unit_id: null, features: null, unit: null, basic: null, prd_loyalty_rate: null, unit_rates: null,
    data: null, prd_supplier: null, prd_tax: null, prd_tax_cat_id: null
  };
  prd_id: any;
  prodsel: string;
  barcode: string;
  isLoading = false;
  result = '';
  disc_request_count: any=0;
  disc_request_list: any;
  status_filter =4;
  status_filters = [
    { id: 0, name: 'Pending' },
    { id: 1, name: 'Approved' },
    { id: 2, name: 'Rejected' },
    { id: 3, name: 'Cancelled' },
    { id: 4, name: 'All' },

  ];
  erpnextRemark = '';
  iserpnextRequest = 0;
  disc_items=[];
  usr_hide_purch_cost: any;
  usr_disply_others_branch_data: any;
  usr_type: any;
  checkMainBranch=0;
  branch_all=[];
  branch_id= 0;
  resubmitLoadingImg=false;
  codes: any;

  
  emp_aprv_req_count: number = 0;
  salary_req_count: number = 0;
  hup: any;
  erpNextSalaryRequestData: any = null;
  hasErpNextSalaryRequest = false;
  erpNextSalaryList: any[] = [];     
  selectedSalaryRequest: any = null;   
  isErpNextSalaryProcessing = false;
  cmp_hr_is_integrated: number = 0;
  show_hr = false;

  constructor(config: NgbModalConfig, private modalService: NgbModal, public translate: TranslateService,
    private apiService: ApiService,public router : Router,private coreService: CoreService,private systemIdService: SystemIdService,) {

    this.searchProductSubject.pipe(
      debounceTime(500),          //wait 500ms after typing stops
      distinctUntilChanged()      //ignore same values
    ).subscribe(value => {
      this.selectProd(value);
    });

    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;

    // translation
    translate.addLangs(['English', 'Chinese', 'Arabic','French','Malay','Bahasa_Indonesia']);

    if (sessionStorage.getItem("baseLang")) {
      translate.use(sessionStorage.getItem("baseLang"));
    } else {
      translate.use('English');
    }

    this.apiService.notificationChange.subscribe(value =>{
        this.pdc_count = value;
    })
    this.apiService.salesordernotificationChange.subscribe(value =>{
      this.so_count = value;
    }); 
    this.apiService.transactionEditReq.subscribe(value =>{
      this.txn_edit_req_count = value;
    });
     this.apiService.salesduenotificationChange.subscribe(value =>{
      this.saledue_count = value;
    });  
      this.apiService.purchaseduenotificationChange.subscribe(value =>{
      this.purchasedue_count = value;
    });
    this.apiService.notificationBatchChange.subscribe(value =>{
      this.batch_ex_count = value;
    })

    this.apiService.pendingEinvoiceNotificationChange.subscribe(value =>{
      this.einvoice_count = value;
    })
    this.apiService.invoiceRequestChange.subscribe(value =>{
      this.invrequest_count = value.count;
      this.invrequest_list = value.list;
      console.log('value');
      console.log(value);

    })
    this.apiService.discountInvoiceRequest.subscribe(value =>{
      this.disc_request_count = value.count;
      this.disc_request_list = value.list;
      console.log('value');
      console.log(value);
    })

    
  }

  open(content) {
    this.modalService.open(content);
  }



  ngOnInit() {
    this.loadHrPrivileges();
    this.branch_id = this.coreService.getUserData('branch_id');
    console.log(" this.branch_id");
    console.log(this.branch_id);
    this.getAllBranch();
    this.mainBranchCheck();
    this.usr_type =this.coreService.getUserData('usr_type');
    this.checkErpNextRequest();
    this.userType =  this.coreService.getUserData('user_type');
    this.user_id =  this.coreService.getUserData('usr_id');
    this.usr_hide_purch_cost = this.coreService.getUserData("usr_hide_purch_cost");
    this.usr_disply_others_branch_data = this.coreService.getUserData('usr_disply_othr_branch_data');
    this.usr_edit_transaction_approval =  this.coreService.getUserData('usr_edit_transaction_approval');
    this.branch_e_invoice_enabled = this.coreService.getUserData('is_e_invoice');
    this.apiService.getClientSettingBykey({ key: 'enable_e_invoice' }).subscribe((res) => {
      if (res['data']) {
        this.eInvoiceSupport = ( (res['data']['cs_value'] ? true : false) && this.branch_e_invoice_enabled) ? true : false;
        this.eInvoiceSupportAdmin = ( (res['data']['cs_value'] ? true : false) && this.userType=='ADMIN') ? true : false;
      }
    });

    this.apiService.getClientSettingBykey({ key: 'Batch Support' }).subscribe((res) => {
      if (res['data']) {
        this.checkBatch = (res['data']['cs_value']) ? true : false;
      }
    });
    this.apiService.getAllClientSettings().subscribe((res) => {
      // console.log(res.data)
      // console.log(res.data.enable_restaurant_pos)
      this.is_rest_pos_enabled = (res.data.enable_restaurant_pos.cs_value) ? res.data.enable_restaurant_pos.cs_value : 0;
      
    })
    this.base_url = this.apiService.PHP_API_SERVER;
  //   if(!sessionStorage.auth_token){
  //     this.router.navigate(['/']);
  //   } 

  

  
  // if(this.userType == 'ADMIN'){
  //   if(this.user_id==1){
  //     this.show_component=true;
  //   }else{
  //     this.show_component=false;
  //   }
    
  // }else{
    this.show_component=true;
  // }
  // this.photo= this.coreService.getUserData('photo');
  this.photo= this.apiService.S3_SERVER + '/uploads/user/' + this.coreService.getUserData('photo');
  this.getEnbaleDisableModuleSettingBykey();
    if(!localStorage.getItem("auth_token")){
   this.router.navigate(['/']);
    }  
    
    this.apiService.updatePDCNotification();
    this.apiService.updateSalesOrderNotification();
    this.apiService.updatebatchExNotification();
    this.apiService.updateEinvoiceNotificationChange();
    this.apiService.updateSalesDueNotification();
    this.apiService.transactionEditReqNotification();
    this.apiService.updatePurchaseDueNotification();
    this.apiService.updateInvoiceRequest('');
    this.apiService.getDiscountInvoiceRequest('');
    this.apiService.updateSalaryRequestNotification();

    this.loadDisplayUserData();
    this.router.events.subscribe(() => {
      this.loadDisplayUserData();
    });
    if(this.admin_notification){
    $("#adminNtfnMdl").click();
  }

    this.apiService.hrEmployeeAdvanceNotification();

    this.apiService.hrEmployeeAdvance.subscribe((count: number) => {
      console.log('COUNT IN HEADER:', count);
      this.emp_aprv_req_count = count || 0;
    });
    this.checkErpNextSalaryRequest ();
    this.getSalaryRequestCount();
    this.getHrIntegrationStatus();
    this.getHrModuleStatus();
  }

  getHrIntegrationStatus() {
    this.apiService.getHrIntegrationStatus().subscribe(
      
      (res: any) => {
        if (res.status) {
          this.cmp_hr_is_integrated = res.cmp_hr_is_integrated;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  goToHrModule() {
    if (this.cmp_hr_is_integrated == 1) {
      this.router.navigate(['/hr-manage']);
    } else {
      this.router.navigate(['/hr-manage/hr-integration']);
    }
  }

  checkErpNextRequest(){
     this.apiService.checkErpNextRequest().subscribe((res) => {
      this.iserpnextRequest = res.status;
    })
  }
  
  searchProducts(value: string) {
    if (value && value.trim() !== '') {
      this.searchProductSubject.next(value);
      this.showProductList = true;
    } else {
      this.showProductList = false;
    }
  }

    selectProd(name: string) {
    let searchval = new FormData();
    searchval.append("prd_name", name);
    searchval.append("flag[]", "0");
    searchval.append("flag[]", "1");
    if(this.prod_alias){
      searchval.append('alias_search', '1');
    }
    this.apiService.getProdByName(searchval).subscribe((res) => {
      this.search = res['data'];
    });
  }
  onNotificationClick(){
    this.apiService.updateInvoiceRequest('');
    this.apiService.getDiscountInvoiceRequest('');
  }
  updateErpNextStatus(status){
    if(status == 3 && this.erpnextRemark == ''){
      this.coreService.showMessage('Failed, Please Enter Remark', 4000);
    } else if (confirm('Do you wish to continue?')) {
        const searchval = {
          'remark': this.erpnextRemark,
          'status': status
        }
        this.apiService.updateEprnextStatus(searchval).subscribe((res) => {
          this.coreService.showMessage(res.message);
          if(res.status == 1){
            this.iserpnextRequest = 0;
            $(".erpnextpopupclose").click();
          }
        });
    }

  }

  refreshBtn(){
      const searchval = {
        'list_all': this.list_all,
      }
    
    this.apiService.updateInvoiceRequest(searchval);

  }
  requestApprv(id,status,msg){
  if (confirm('Do you wish to '+msg+' this request?')) {
   
      const searchval = {

        'sia_id': id,
        'status': status,
      }
      this.apiService.updateInvReqStatus(searchval).subscribe((res) => {
        this.coreService.showMessage(res.message);
        this.apiService.updateInvoiceRequest('');
      });
  }
  }
  getEnbaleDisableModuleSettingBykey() {
    this.apiService.getEnbaleDisableModuleSettingBykey().subscribe((res) => {
      if (res['data']) {
        this.show_production = (res['data']['enable_production']) ? true: false;
        this.show_documentation = (res['data']['enable_documentation']) ? true: false;
      } 
    });
  }

  selDefault(lang) {
    alert("lang");
  }

  changeLang(bLang) {
    this.translate.use(bLang);
    sessionStorage.setItem("baseLang", bLang);
    this.apiService.updateLanguage();
    // if(this.router.url=="/ledger_detail_rep"){
    //   window.location.reload();
    // }
  }

  searchMenu(search: string) {
    if(search){
      let searchval = new FormData();
      searchval.append("keyword", search);
      this.apiService.searchMenu(searchval).subscribe((res) => {
        this.search_res = res['data'];
      });
      $('.search-list').show();
    }else{
      $('.search-list').hide();
    }
    
  }
  gotopage(link){
    $('.search-list').hide();
    this.search_inp = '';
    this.router.navigate(['/'+link]);
  }

  goToProduct(prdId) {
    this.isLoading = true;
    this.showProductList = false;
    this.search_inp = '';
    let searchval = new FormData();
    searchval.append("prd_id", prdId);
    this.apiService.getProductGlobalSearch(searchval).subscribe((res) => {
      this.productDetails = res['data']['products'];
      this.unit_available_stock = this.productDetails.bs_stock_quantity_shop;
      this.godownStocks = res['data']['stock_summary']['data']; 
      this.vanStocks = res['data']['van_stock'];
      this.otherBranchStocks = res['data']['other_branch_stocks'];
      this.isLoading = false;
      this.prd_id = res['data']['products']['prd_id'];
      this.rate_history(this.prd_id);
    });
  }

  tabClick(tab) {    
    this.result = ''; 
  }

  tabChanged(event) {
  if (event.index === 1) { // History tab
    this.rate_history(this.prd_id);
  }
}

 rate_history(prd_id) {
   if (!prd_id) {
    $("#ifrm").attr("src", "about:blank");
    return;
  }
    this.prd_id=prd_id;
    this.desktoken =localStorage.cmptoken; 
    $("#ifrm").attr("src", ((environment.php_api_server != '') ? environment.php_api_server : `${window.location.origin}/backend`) + "/product-history?prod_id="+prd_id +"&desktoken="+this.desktoken+"&user="+this.user_id+"&Lang="+this.translate.currentLang);
  
  }

  onProductChange(product: any) {
    if (product && product.prd_id) {
      this.goToProduct(product.prd_id);
      this.rate_history(product.prd_id);
      this.barcode = '';
      $("#br_err").text("");
     } else {
      this.productDetails = null;
      this.unit_available_stock = 0;
      this.godownStocks = [];
      this.vanStocks = [];
      this.otherBranchStocks = [];
      this.prd_id = null;
      this.rate_history(null);
    }
      
  }

  searchByBarcode(barcode: string) {
    if (!barcode) {
      $("#br_err").text("Enter Barcode");
      return false;
    } else {
      $("#br_err").text("");
    }
    this.isLoading = true;
    let searchval = new FormData();
    searchval.append("keyword", barcode);
    searchval.append("barcode", barcode);
    this.apiService.getProductGlobalSearch(searchval).subscribe((res: any) => {
      if (!res.data || res.data.length === 0) {
        $("#br_err").text("Barcode not found");
        this.isLoading = false;
        return;
      }
      this.productDetails = res['data']['products'];
      this.unit_available_stock = this.productDetails.bs_stock_quantity_shop;
      this.prd_id = this.productDetails.prd_id;
      searchval.append("prd_id", this.prd_id);
      this.godownStocks = res['data']['stock_summary']['data'];
      this.vanStocks = res['data']['van_stock'];
      this.otherBranchStocks = res['data']['other_branch_stocks'];
      this.isLoading = false;
      this.rate_history(this.prd_id);
    });
  }

  clearProductSelect() {
    this.prodsel = null;
    this.productDetails = null;
    this.godownStocks = [];
    this.vanStocks = [];
    this.otherBranchStocks = [];
    this.unit_available_stock = 0;
    this.isLoading = false;
    this.rate_history(null);
    this.prd_id = null;
  }

  clearProductModal() {
    this.productDetails = null;
    this.godownStocks = [];
    this.vanStocks = [];
    this.otherBranchStocks = [];
    this.unit_available_stock = 0;
    this.prodsel = null;
    this.barcode = '';
    $("#br_err").text("");
    this.isLoading = false;
    this.rate_history(null);
    this.prd_id = null;
  }
    


  // search(e) {
  //   const filter = $('#search').val().toString().toLowerCase();
  //   // filter = filter.toLowerCase();
  //   const nodes = $('.card-body');
  //   let isElemnt = false;
  //   // let  divEml;

  //   let divEml: any;
  //   if ($('.menu_page .col-xl-3').length) {
  //     divEml = $('.menu_page .col-xl-3');
  //     isElemnt = true;
  //   }

  //   if ($('.sub_menu_page .col-xl-2').length){
  //     divEml = $('.sub_menu_page .col-xl-2');
  //     isElemnt = true;
  //   }
  //   if (isElemnt === true) {
  //     for (let i = 0; i < nodes.length; i++) {
  //       if (nodes[i].innerText.toLowerCase().includes(filter)) {
  //         divEml[i].style.display = 'block';
  //       } else {
  //         divEml[i].style.display = 'none';
  //       }
  //     }
  //   }
  // }

  loadHrPrivileges() {
    const userId = this.coreService.getUserData('usr_id');
    if (!userId) return;

    let searchval = new FormData();
    searchval.append("usr_id", userId);

    this.apiService.getHrUserPrivilage(searchval).subscribe((res) => {
      console.log('HR Privileges from API:', res);
      
      if (res && res['data']) {
        this.hup = res['data'];
        // Save to localStorage
        this.coreService.setLocalStorage('hrurpg', JSON.stringify(this.hup));
      } else {
        this.hup = {};
      }
      
      console.log('hup loaded:', this.hup);
    });
  }
  loadDisplayUserData() {
    let data = this.coreService.getUserData('branch_name');
    this.branch_name = data ? data : '';
    this.up = this.coreService.getUserPrivilage();
    this.hup = this.coreService.getHrUserPrivilage() || {};
    this.display_name = this.coreService.getUserData('branch_disp_name');
    // this.branch_name= this.coreService.getUserData('branch_name');
    this.display_code = this.coreService.getUserData('branch_code');
    this.user_name = this.coreService.getUserData('usr_name');
    this.usr_username = this.coreService.getUserData('usr_username');
    this.admin_notification = this.coreService.getUserData('admin_notification');
    this.cmpny = this.coreService.getUserData('cmpny');
  }
  discRequestApprv(id, status, msg) {
    if (confirm('Do you wish to ' + msg + ' this request?')) {
      const searchval = {
        'sda_id': id,
        'status': status,
      }
      this.apiService.updateDiscReqStatus(searchval).subscribe((res) => {
        console.log("res.error");
        console.log(res.error.error);
        if(res.error){
           if (confirm(res.error.error)) {
           }
        }
        else{
           this.coreService.showMessage(res.message);
        }
       
        this.apiService.getDiscountInvoiceRequest('');
      });
    }
  }
  ChangeStatus(status_id){
    const searchval = {
      'status_id': status_id,
    }
    this.apiService.getDiscountInvoiceRequest(searchval);
  }

  discApprovalSubData(items){
    this.disc_items =items;
  }
  
  checkErpNextSalaryRequest() {
    this.apiService.checkErpNextSalaryRequest().subscribe((res: any) => {
      if (res.status == 1 && res.data.length > 0) {
        this.hasErpNextSalaryRequest = true;
        this.erpNextSalaryList = res.data;
      } else {
        this.hasErpNextSalaryRequest = false;
        this.erpNextSalaryList = [];
      }
    });
  }

  openSalaryModal(item: any) {
    this.selectedSalaryRequest = item;
  }

  acceptErpNextSalaryRequest() {
    this.updateErpNextSalaryStatus(1);
  }

  updateErpNextSalaryStatus(status: number) {
    if (!confirm('Do you wish to continue?')) {
      return;
    }

    this.isErpNextSalaryProcessing = true;

    const searchval = {
      status: status,
      payroll_id: this.selectedSalaryRequest.payroll_id
    };

    this.apiService.updateErpNextSalaryStatus(searchval).subscribe((res: any) => {
      this.isErpNextSalaryProcessing = false;

      if (res.status == 1 || res.status === true) {
        this.coreService.showMessage(res.message || 'Success');

        this.erpNextSalaryList = this.erpNextSalaryList.filter(
          item => item.payroll_id !== this.selectedSalaryRequest.payroll_id
        );

        if (this.erpNextSalaryList.length === 0) {
          this.hasErpNextSalaryRequest = false;
        }

        this.selectedSalaryRequest = null;
        $('.erpnextSalaryApprovalClose').click();
      } else {
        this.coreService.showMessage(res.message || 'Something went wrong');
      }
    }, () => {
      this.isErpNextSalaryProcessing = false;
      this.coreService.showMessage('Server error');
    });
  }
    
  getSalaryRequestCount() {
    this.apiService.salaryRequestNotification.subscribe((value: any) => {
      this.salary_req_count = value;
    });
  }

  getHrModuleStatus() {
    this.apiService.getErpModuleStatus({}).subscribe((res: any) => {
      const moduleActive = res && res.status == 1;
      const isSuperAdmin = this.userType == 'ADMIN' && this.user_id == 1;
      this.show_hr = moduleActive && !isSuperAdmin;
    });
  }

  mainBranchCheck() {
    this.checkMainBranch = 0;
    let searchval = new FormData();
    searchval.append("user_branch_id", this.coreService.getUserData('branch_id'));
    this.apiService.mainBranch(searchval).subscribe((res) => {
      if (res) {
        //this.checkMainBranch = 1;
        this.checkMainBranch = res['status'];
      } 
    });
  }

  getAllBranch() {
    this.apiService.readAllActiveBranch().subscribe((res:any) => {
      this.branch_all = res.data;
    });
  }

  submitBranch(branch_id) {
    this.resubmitLoadingImg =true;
    let searchval = new FormData();
    searchval.append("selected_branch_id", branch_id);
    searchval.append("user_id", this.user_id);

    const system_Id = this.systemIdService.getSystemId();
    searchval.append("system_id", system_Id);
    this.apiService.supportLogin(searchval).subscribe((res:any) => {
     if(res){
        if (res.error != null) {
         this.result = res.error;
        }
        else {
          localStorage.clear();
          this.branch_name = this.coreService.getUserData('branch_name');
          this.branch_name = null;
          this.result = '';
          localStorage.removeItem("cmptoken");
          localStorage.removeItem("auth_token");
          localStorage.removeItem("lcstg");
          localStorage.removeItem("urpg");
          this.coreService.removeLocalStorage('lcstg');
          this.coreService.removeLocalStorage('urpg');

          //this.coreService.createfunct(form, this.result, "Login Success");
          document.cookie = "bquick=loggedin";
          localStorage.setItem("cmptoken", res.cmptoken);
          localStorage.setItem("auth_token", res.token);
          localStorage.removeItem("isBquickReloading");
          // localStorage.setItem("lcstg", CryptoJS.AES.encrypt(JSON.stringify(res.profile),'dKVFujk').toString());  
          this.coreService.setLocalStorage('lcstg', JSON.stringify(res.profile));
          this.coreService.setLocalStorage('urpg', JSON.stringify(res.usrPrvlg));

          console.log("Branch");
          console.log(this.coreService.getUserData('branch_name'));
          console.log("UserType");
          console.log(this.coreService.getUserData('user_type'));
          this.apiService.getRates().subscribe((rescod: any) => {
            if (rescod) {
              this.codes = rescod.rcd_code.split(';');
              this.coreService.setLocalStorage('rate_codes', JSON.stringify(this.codes));
            }
          });
          this.apiService.getBlockTransactionSettings().subscribe((response: any) => {
            if (response.data == 1) {
              this.coreService.setLocalStorage('txnb', '1');
            } else {
              this.coreService.setLocalStorage('txnb', '0');
            }
          });
          this.router.navigate(['/master']);
          // window.location.reload();
          this.display_name = this.coreService.getUserData('branch_disp_name');
          this.cmpny = this.coreService.getUserData('cmpny');
          this.branch_name = this.coreService.getUserData('branch_name');
          this.display_code = this.coreService.getUserData('branch_code');
          this.branch_id = this.coreService.getUserData('branch_id');
          console.log("this.display_name");
          console.log(this.display_name);
          console.log("cmpny");
          console.log(this.cmpny);
          console.log("branch_name");
          console.log(this.branch_name);
          this.ngOnInit();

          this.resubmitLoadingImg = false;
         
        }
       
       


     }
    });
  }
}
